import { useSelector } from 'react-redux'
import styled from 'astroturf/react'
import { Button } from '@calendly/ui/components/button'
import { IconArrowsMaximize } from '@calendly/ui/components/glyphs/IconArrowsMaximize'
import { IconExternalLink } from '@calendly/ui/components/glyphs/IconExternalLink'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { useFlag } from '@calendly/feature-check-react'
const spacing1x = 'var(--spacing-1x, 1rem)'

import { emailSelector } from 'selectors/publisher'
import { useI18n } from 'locales'
import _StyledGmailButton from "gmail_confirmation-StyledGmailButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/gmail_confirmation.js?styleId=StyledGmailButton";
import _RedesignedGmailButton from "gmail_confirmation-RedesignedGmailButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/gmail_confirmation.js?styleId=RedesignedGmailButton";


const StyledGmailButton = /*#__PURE__*/styled(Button, null, {
  displayName: "StyledGmailButton",
  styles: _StyledGmailButton
})

const RedesignedGmailButton = /*#__PURE__*/styled(Button, null, {
  displayName: "RedesignedGmailButton",
  styles: _RedesignedGmailButton
})

export const GmailConfirmation = () => {
  const { i18n } = useI18n()
  const publisherEmail = useSelector(emailSelector)
  const emailAuthor = `%7Bfrom%3A${publisherEmail} from%3Ano-reply@calendly.com from%3Anotifications@calendly.com%7D`
  const gmailLink = `https://mail.google.com/mail/u/0/#search/${emailAuthor}+in%3Aanywhere+newer_than%3A1d`
  const bookingAppRedesign = useFlag('booking_app_redesign', false)

  const handleGmailLinkClick = () => {
    window.open(gmailLink, '_blank')
  }

  const label = i18n.t('booking.templates.open_invitation')

  return bookingAppRedesign ? (
    <RedesignedGmailButton
      id="booking_sniper_link_cta"
      appearance="ghost"
      size="small"
      onClick={handleGmailLinkClick}
      rel="noopener noreferrer"
      aria-label={label}
    >
      <UiIcon icon={IconExternalLink} size="small" />
      {label}
    </RedesignedGmailButton>
  ) : (
    <StyledGmailButton
      id="booking_sniper_link_cta"
      onClick={handleGmailLinkClick}
      decoration="secondary-outline"
      size="small"
      rel="noopener noreferrer"
      aria-label={label}
    >
      {label}
      <UiIcon icon={IconArrowsMaximize} size="small" />
    </StyledGmailButton>
  )
}
